<template>
  <input v-model="allobjlist.objlist[allindex].kaoshenganswer[duanindex][zuizhongindex]" :style="style1" @click="showdaan()" readonly/>
</template>

<script>
import global from '../components/global'

export default {
  props: ['duanindex', 'allindex', 'zuizhongindex', 'singleanswerlist', 'kaoshenganswerlistsingle', 'fontsize'],
  data () {
    return {
      allobjlist: global.allobjlist,
      list: global.list,
      // answerlist: global.answerlist,
      yonghuming: global.yonghuming
      // fontsize: global.fontsize
    }
  },
  methods: {
    showdaan (e) {
      const f = this.$jiankongdata.countclick.pop() + 1
      // const t = this.$jiankongdata.timestart
      // :style="style1"
      this.$jiankongdata.countclick.push(f)
      this.$toast(this.allobjlist.objlist[this.allindex].answerlist[this.duanindex][this.zuizhongindex])
    }
  },
  computed: {

    intext: function () {
      return this.allobjlist.objlist[this.allindex].answerlist[this.duanindex][this.zuizhongindex]
    },
    style1: function () { // App.vue下设了fontsize为15px,:size="size"太差,改为style
      let style = this.allobjlist.objlist[this.allindex].answerlist[this.duanindex][this.zuizhongindex].length * this.fontsize + 'px'
      style = 'width:' + style + ';height:' + this.fontsize + 'px'
      return style
    }
  },
  watch: {
    fontsize: function () { // this.style1 = 'font-size:' + (this.fontsize) + 'px'
      // alert(global.fontsize)
    }
  },
  mounted: function () {
    // alert(global.fontsize)
  }
  /* updated: function () {
    const x = document.getElementsByTagName('input')
    const y = x.length
    for (let i = 0; i < y; i++) { x[i].width = global.fontsize + 'px' }
  } */
}
</script>
